import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const TermsOfServicePage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-indigo-50">
      <Navbar />
      
      <div className="pt-32 pb-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <div className="inline-flex items-center px-4 py-2 rounded-full bg-indigo-100 border border-indigo-200 mb-6">
              <span className="w-2 h-2 bg-indigo-600 rounded-full mr-2 animate-pulse"></span>
              <span className="text-sm font-medium text-indigo-700 uppercase tracking-wider">
                Legal
              </span>
            </div>
            <h1 className="text-5xl font-bold text-gray-900 mb-4">Terms of Service</h1>
            <p className="text-gray-600">Last updated: January 1, 2024</p>
          </div>

          {/* Content */}
          <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12">
            <div className="prose prose-lg max-w-none">
              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Agreement to Terms</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  By accessing or using AdBlastX's services, you agree to be bound by these Terms of Service and all 
                  applicable laws and regulations. If you do not agree with any of these terms, you are prohibited from 
                  using or accessing our services.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Services Description</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  AdBlastX provides the following services:
                </p>
                <ul className="list-disc list-inside text-gray-600 space-y-2 ml-4">
                  <li>META Ads (Facebook & Instagram) campaign management and optimization</li>
                  <li>Google Ads (Search & Display) campaign management and optimization</li>
                  <li>Custom software development and web applications</li>
                  <li>Mobile application development (iOS & Android)</li>
                  <li>AI-powered solutions and machine learning integration</li>
                  <li>Digital marketing consulting and strategy</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">3. User Obligations</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  As a user of our services, you agree to:
                </p>
                <ul className="list-disc list-inside text-gray-600 space-y-2 ml-4">
                  <li>Provide accurate, current, and complete information</li>
                  <li>Maintain the security of your account credentials</li>
                  <li>Notify us immediately of any unauthorized use of your account</li>
                  <li>Comply with all applicable laws and regulations</li>
                  <li>Not use our services for any illegal or unauthorized purpose</li>
                  <li>Not interfere with or disrupt the services or servers</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Payment Terms</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Payment terms for our services:
                </p>
                <ul className="list-disc list-inside text-gray-600 space-y-2 ml-4">
                  <li>All fees are quoted in USD unless otherwise specified</li>
                  <li>Payment is due according to the payment schedule outlined in your service agreement</li>
                  <li>Late payments may result in service suspension</li>
                  <li>Refunds are subject to our refund policy as outlined in your service agreement</li>
                  <li>We reserve the right to change our fees with 30 days notice</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Intellectual Property</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  The service and its original content, features, and functionality are and will remain the exclusive 
                  property of AdBlastX. Our services are protected by copyright, trademark, and other laws. Our trademarks 
                  may not be used in connection with any product or service without our prior written consent.
                </p>
                <p className="text-gray-600 leading-relaxed mb-4">
                  For custom development projects, intellectual property rights will be transferred to the client upon 
                  full payment, unless otherwise specified in the project agreement.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Service Level Agreement</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  We strive to provide reliable services with the following commitments:
                </p>
                <ul className="list-disc list-inside text-gray-600 space-y-2 ml-4">
                  <li>99.9% uptime for hosted services</li>
                  <li>24-hour response time for support inquiries</li>
                  <li>Regular performance monitoring and optimization</li>
                  <li>Scheduled maintenance with advance notice</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Limitation of Liability</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  In no event shall AdBlastX, nor its directors, employees, partners, agents, suppliers, or affiliates, 
                  be liable for any indirect, incidental, special, consequential or punitive damages, including without 
                  limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from:
                </p>
                <ul className="list-disc list-inside text-gray-600 space-y-2 ml-4">
                  <li>Your access to or use of or inability to access or use the service</li>
                  <li>Any conduct or content of any third party on the service</li>
                  <li>Any content obtained from the service</li>
                  <li>Unauthorized access, use or alteration of your transmissions or content</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Termination</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  We may terminate or suspend your account and access to our services immediately, without prior notice 
                  or liability, for any reason whatsoever, including without limitation if you breach the Terms. Upon 
                  termination, your right to use the services will immediately cease.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Confidentiality</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Both parties agree to maintain the confidentiality of any proprietary information received during the 
                  course of our business relationship. This includes but is not limited to business strategies, customer 
                  data, technical information, and financial information.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">10. Governing Law</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  These Terms shall be governed and construed in accordance with the laws, without 
                  regard to its conflict of law provisions. Our failure to enforce any right or provision of these Terms 
                  will not be considered a waiver of those rights.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">11. Changes to Terms</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  We reserve the right to modify or replace these Terms at any time. If a revision is material, we will 
                  provide at least 30 days notice prior to any new terms taking effect. What constitutes a material change 
                  will be determined at our sole discretion.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">12. Contact Information</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  If you have any questions about these Terms of Service, please contact us:
                </p>
                <div className="bg-indigo-50 rounded-xl p-6 border border-indigo-200">
                  <p className="text-gray-700 font-semibold mb-2">Email:</p>
                  <a href="mailto:contact@AdBlastX.com" className="text-indigo-600 hover:text-indigo-700 font-semibold">
                    contact@AdBlastX.com
                  </a>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default TermsOfServicePage;
